<script setup>
import {
  computed,
  h,
} from 'vue';

import clsx from 'clsx';
import {
  RouterLink,
  useRouter,
} from 'vue-router';

import Reputation from '@/components/Icons/Reputation.vue';
import Verified from '@/components/Icons/Verified.vue';
import { BaseURL } from '@/global/baseUrls.js';

const props = defineProps({
  src: {
    type: String,
    default: "",
  },
  href: {
    type: String,
    default: ''
  },
  storageId: {
    type: String,
    default: ""
  },
  size: {
    type: String,
    default: "",
  },
  classes: {
    type: String,
    default: "",
  },
  verified: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
    default: 16
  },
  height: {
    type: Number,
    default: 16
  },
  isAdmin: {
    type: Boolean,
    default: false,
  },
  isOrg: {
    type: Boolean,
    default: false,
  }
})

const getSrc = computed(() => {
  if (props.src) {
    return props.src
  }
  if (props.storageId) {
    return BaseURL+props.storageId
  }
  if(props.isOrg) {
    return '/images/orgava.svg'
  }
  return '/images/DefaultAvatar.svg'
})

</script>

<template>
  <component
      @click.stop
      :is="props.href ? 'RouterLink' : 'div'"
      :to="props.href || undefined" 
      class="avatar" 
      :class="clsx({'border-none': isOrg}, size, classes)"
  >
    <img
        class="avatar-img"
        :src="getSrc"
        alt="user's avatar"
    />
    <span v-if="verified" class="absolute bottom-[-3px] right-[-3px] flex items-center">
      <component 
        :is="isAdmin ? Reputation : Verified"
        :style="{width: `${width}px`, height: `${height}px`}"
      />
    </span>
  </component>
</template>

<style scoped lang="scss">
.avatar {
  display: block;
  width: 40px;
  height: 40px;
  border: 1px solid #71767b;
  position: relative;
  border-radius: 100%;

  &-img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  &.lg {
    width: 66px;
    height: 66px;
  }
}
</style>